/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useEffect, useState } from "react";
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { TextField } from 'formik-mui';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';

import { getAllGetchkdUsers } from '../../../../../store/reducers/getchkdUser/getchkdUserAction';


const OktaUserCreationForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const [showPassword, setShowPassword] = useState(false)
    const dispatch = useDispatch();
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers);

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(getAllGetchkdUsers()).unwrap();

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [dispatch]);



    return (

        <>
            <Form>

                <Grid container spacing={4}><Grid item xs={12} md={12} sm={12}>

                    {values.hasOwnProperty("getChkdID") &&
                        <FormControl fullWidth error={Boolean(touched.getChkdID && errors.getChkdID)}>
                            <InputLabel htmlFor="outlined-status">Getchkd User</InputLabel>
                            <Select
                                value={values.getChkdID}
                                variant="outlined"
                                name="getChkdID"
                                label="Getchkd User"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((item) => (
                                    <MenuItem value={item.getChkdID}>
                                        {item.username}
                                    </MenuItem>
                                ))}


                            </Select>
                            {errors.getChkdID && <FormHelperText style={{ color: "red" }} >{errors.getChkdID}</FormHelperText>}

                        </FormControl>
                    }


                    {values.hasOwnProperty("firstName") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="firstName"
                                label="First Name"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.firstName}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl></Grid>
                    }

                    {values.hasOwnProperty("lastName") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="lastName"
                                label="Last Name"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.lastName}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl></Grid>
                    }
                    {values.hasOwnProperty("email") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="email"
                                label="Email"
                                type="email"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.email}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl></Grid>
                    }
                    {values.hasOwnProperty("login") && <Grid item xs={12} md={12} sm={12}>
                        <FormControl fullWidth >

                            <Field
                                name="login"
                                label="Login"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.login}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl></Grid>
                    }

                    {values.hasOwnProperty("password") && <Grid item xs={12} md={12} sm={12}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl fullWidth error={Boolean(touched.password && errors.password)}>

                                    <Field
                                        name="password"
                                        label="Password"
                                        type={showPassword ? "text" : 'password'}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        value={values.password}
                                        component={TextField}
                                        InputProps={{

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                    >
                                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                    <Field
                                        value={values.confirmPassword}
                                        component={TextField}

                                        name="confirmPassword"
                                        label="Confirm Password"
                                        type={showPassword ? "text" : 'password'}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        InputProps={{

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                    >
                                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid></Grid>

                    }
                </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ marginTop: '20px' }}
                            disabled={isSubmitting}>
                            {isSubmitting &&
                                <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                        </Button>
                        <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                    </Grid>

                </Grid>
            </Form>
        </>
    )

}
export default OktaUserCreationForm;